import { get } from 'lodash';
export class CoverageForm {
  sumAssured: number | undefined;
  policyTerm: string | undefined;
  planPremiumMode: string | undefined;
  illnessCover: number | undefined;

  constructor(initial: any) {
    this.sumAssured = get(initial, 'sumAssured', undefined);
    this.policyTerm = get(initial, 'policyTerm', '5');
    this.planPremiumMode = get(initial, 'planPremiumMode', 'AP');
    this.illnessCover = get(initial, 'illnessCover', undefined);
  }
}